/**
 * <lih-products> — Shop By Size & Material on the Live In Hoops landing page.
 *
 * Markup contract:
 *   <lih-products id="shop-live-in-hoops" class="lp-live-in-hoops-products">
 *
 * CTA / other sections: <a href="#shop-live-in-hoops" data-lih-goto-products>
 * Without JS the hash still lands on this element.
 */
class LihProducts extends HTMLElement {
  connectedCallback() {
    this.onDocumentClick = this.onDocumentClick.bind(this);
    document.addEventListener('click', this.onDocumentClick, true);
  }

  disconnectedCallback() {
    document.removeEventListener('click', this.onDocumentClick, true);
  }

  onDocumentClick(event) {
    const jump = event.target.closest('[data-lih-goto-products]');
    if (
      !jump ||
      this.contains(jump) ||
      event.defaultPrevented ||
      event.metaKey ||
      event.ctrlKey ||
      event.shiftKey ||
      event.altKey
    ) {
      return;
    }

    event.preventDefault();
    this.scrollIntoView({
      behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth',
      block: 'start',
    });
  }
}

if (!customElements.get('lih-products')) {
  customElements.define('lih-products', LihProducts);
}
